import CardValidator from 'card-validator';
import orderBy from 'lodash/orderBy';

import { CardTypeConfig } from '../interfaces/card-type-config';

export function addCardType(config: CardTypeConfig, order?: number) {
    CardValidator.creditCardType.addCard(config);

    if (order) {
        CardValidator.creditCardType.changeOrder(config.type, order);
    }
}

export function getCardTypesOrderByPopularity(cardTypes: Array<string>, order: Array<string>) {
    return orderBy(cardTypes, (cardType) => {
        if (order.indexOf(cardType) > -1) {
            return order.indexOf(cardType);
        }

        return null;
    });
}
